import React, { useState } from 'react'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import Avatar from '@material-ui/core/Avatar'
import { makeStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'

import { H3 } from '../../../../components/UI/index'
import Chip from './../Chip/Chip'
import BlankProfile from './../../../../assets/images/blank-profile.png'
import styles from './ConsultantCard.module.scss'
import SocialNetworks from '../../../../components/Main/SocialNetworks'
import Description from '../../../../components/Main/Description/Description'

const useStyles = makeStyles({
	root: {
		minWidth: 275,
		maxWidth: 336
	},
	bullet: {
		display: 'inline-block',
		margin: '0 2px',
		transform: 'scale(0.8)'
	},
	title: {
		fontSize: 18
	},
	pos: {
		marginBottom: 12
	},

})
const ConsultantCard = (props) => {
	const classes = useStyles()

	const [descriptionStatus] = useState(false)

	const descriptionStyles = [styles.Description]
	if (descriptionStatus) {
		descriptionStyles.push(styles.ActiveDescription)
	}
	const arrowStyles = [styles.Arrow]
	if (descriptionStatus) {
		arrowStyles.push(styles.ActiveArrow)
	}

	return (
		<div className={styles.Card}>
				<Link to={`/consultants/${props.counselingCenterUsername}/${props.consultant.username}`} style={{
					textDecoration: 'none'
				}}>
					<div className={styles.consultantProfileContainer}>
						<div>
							<Avatar
								className={styles.Avatar}
								variant="rounded"
								alt={props.consultant.first_name + ' ' + props.consultant.last_name}
								src={props.consultant.profile_url ? props.consultant.profile_url : BlankProfile}
							/>
						</div>
						<div>
							<div>
								<H3>{props.consultant.first_name} {props.consultant.last_name}</H3>
								<SocialNetworks  socialNetworks={props.consultant.social_networks}/>
							</div>
						</div>
					</div>
					<Grid item xs={12}>
						<div className={styles.Chips}>
							{props.consultant.services.map(service => (
								<Chip chipType={service.pattern} label={service.title} key={service.title}/>
							))}
						</div>
					</Grid>

				<Description description={props.consultant.description}/>
				</Link>

		</div>
	)
}

export default ConsultantCard
